export default {
    actions:{
         // дабавляет новый раздел (счет)
         accountSectionAdd: function({dispatch}, description){
            let info = JSON.parse(description)
            window.BX24.callMethod('entity.get', {}, function(result)
            {
                if (result.error())
                {
                    let alert = 'Ошибка проверки хранилища'
                    dispatch('alertInfo', alert, {root: true})
                    console.log(result.error())
                }
                else
                {
                    let store = result.data()
                    let storeflag = false
                    console.log(`Хранилище Битрикс24 найдено, размер ${store.length}`);
                    for (var i=0;i<store.length; i++){
                        if (store[i]['ENTITY'] == "store"){
                            storeflag = true
                            break
                        }
                    }
                    if (storeflag) {
                        sectionAdd()
                    } else createStoreStore() //TODO Вынесьти в исталляцию
                }
            })

            // создает хранилище, если его не было
            function createStoreStore(){
                console.log('Создаем хранилище Битрикс24');
                BX24.callMethod('entity.add',
                {
                    "entity": "store",
                    "NAME": "store",
                    "access": {
                        AU: "W"
                    }
                },
                function(result)
                {
                    if (result.error())
                    {
                        let alert = 'Ошибка создания хранилища'
                        dispatch('alertInfo', alert, {root: true})
                        console.log(result.error())
                    }
                    else
                    {
                        sectionAdd()
                    }
                })
            }

                function sectionAdd()
                {
                    BX24.callMethod('entity.section.add',
                    {
                        ENTITY: 'store',
                        NAME: info.name,
                        DESCRIPTION: description
                    },
                    function(result)
                    {
                        if (result.error())
                        {
                            let alert = 'Ошибка создания счета'
                            dispatch('alertInfo', alert, {root: true})
                            console.log(result.error())
                        }
                        else
                        {
                            let infoSucces = 'Счет успешно добавлен'
                            dispatch('succesInfo', infoSucces, {root: true})
                            dispatch('accounsInformation',null, {root: true})
                        }
                    })
                }
        },
        // изменяет активность счета (раздела)
        changeSection: function({dispatch},{Activ, ID, name}){
            let infoSucces
            let change
            if (Activ == "Y"){
                change = "N"
                infoSucces = 'Счет "' +name+'" не будет отображаться в таблице'
            } else if (Activ == "N"){
                change = "Y"
                infoSucces = 'Счет "'+name+'" будет отображаться в таблице'
            }

            BX24.callMethod('entity.section.update',
            {
                ENTITY: 'store',
                ID: ID,
                ACTIVE: change
            },
            function(result)
            {
                if (result.error())
                {
                    let alert = 'Ошибка активности'
                    dispatch('alertInfo', alert, {root: true})
                    console.log(result.error())
                }
                else
                {
                    dispatch('succesInfo', infoSucces, {root: true})
                    dispatch('accounsInformation', null, {root: true})
                }
            })
        },
        // меняет реквизиты счета (раздела)
        changeName: function({dispatch}, {Name,ID,NumberCh,type,key,summ,dateBalance}){
            let description
            if (key == undefined){
                description = JSON.stringify({
                    "name": Name,
                    "number": NumberCh,
                    "type": type,
                    "summ": summ,
                    "dateBalance": dateBalance
                });
            } else {
                description = JSON.stringify({
                    "name": Name,
                    "key": key,
                    "number": NumberCh,
                    "type": type,
                    "summ": summ,
                    "dateBalance": dateBalance
                });
            }

            BX24.callMethod('entity.section.update',
            {
                ENTITY: 'store',
                ID: ID,
                NAME: Name,
                DESCRIPTION: description
            },
            function(result)
            {
                if (result.error())
                {
                    let alert = 'Ошибка заммены данных счета'
                    dispatch('alertInfo', alert, {root: true})
                    console.log(result.error())
                }
                else
                {
                    let infoSucces = 'Счет поменял данные'
                    dispatch('succesInfo', infoSucces, {root: true})
                    dispatch('accounsInformation', null, {root: true})
                }
            })
        },
        // удаляет счет (раздел)
        deleteSection: function({commit,dispatch}, id){
            let process = 'Счет удаляется'
            dispatch('alertInfo', process, {root: true})

            BX24.callMethod('entity.section.delete',
            {
                ENTITY: 'store',
                ID: id
            },
            function(result)
            {
                if (result.error())
                {
                    let alert = 'Ошибка удаления счета'
                    dispatch('alertInfo', alert, {root: true})
                    console.log(result.error())
                }
                else
                {
                    let infoSucces = 'Счет успешно удален'
                    dispatch('succesInfo', infoSucces, {root: true})
                    dispatch('accounsInformation',null , {root: true})
                }
            })
        },
    }
}